import axiosInstance from './axiosInstance'

export const lookupVerticalSupportEngineering = (oahFt, oawFt) => {
  return axiosInstance.get(`/vertical-support-engineering/lookup?oahFt=${oahFt}&oawFt=${oawFt}`)
}

export const getEngineeringTubeSizes = () => {
  return axiosInstance.get('/vertical-support-engineering/tube-sizes')
}

export const getEngineeringTableRows = () => {
  return axiosInstance.get('/vertical-support-engineering')
}

export const getEngineeringTableRowById = (id) => {
  return axiosInstance.get(`/vertical-support-engineering/${id}`)
}

export const createEngineeringTableRow = (data) => {
  return axiosInstance.post('/vertical-support-engineering', data)
}

export const updateEngineeringTableRow = (id, data) => {
  return axiosInstance.put(`/vertical-support-engineering/${id}`, data)
}

export const deleteEngineeringTableRow = (id) => {
  return axiosInstance.delete(`/vertical-support-engineering/${id}`)
}
